<template>
  <upModel
    title="壹心理保障"
    :show="show"
    @close="close"
    :showCloseBtn="true"
    :autoHeight="false"
    :disableBodyScroll="true"
    :buttons="buttons"
    class="hp-up-popup-container consult-ensure-rule-model-box"
    :style="{ 'z-index': zIndex }"
  >
    <div class="hp-up-popup-rule-model consult-ensure-rule-model">
      <div>
        <dl class="list" v-for="(item, index) in rules" :key="index">
          <dt class="title" v-if="item.title">
            <img
              :src="require(`./img/${item.icon}.png`)"
              alt=""
              v-if="item.icon"
              class="item-icon"
            />{{ item.title }}
          </dt>
          <dd
            :class="{ desc: true, 'desc-pb': index === 5 }"
            v-html="item.desc"
          ></dd>
        </dl>
      </div>
      <div>
        <img src="./img/expert-list.png" alt="" class="expert-list" />
      </div>
      <dl class="list">
        <dd class="desc desc-last">
          客服电话:400-788-9001(转接心理咨询业务)<br />
          客服时间:工作日10:00-19:00
        </dd>
      </dl>
    </div>
  </upModel>
</template>

<script>
import upModel from '../upModel/upModel.vue'

export default {
  components: {
    upModel
  },
  props: {
    rules: {
      type: Array,
      default() {
        return [
          {
            icon: 'lock',
            title: '隐私保护',
            desc:
              '充分尊重每位来访者的隐私，全方位保护你的个人信息和个案记录的安全'
          },
          {
            icon: 'refund',
            title: '5轮甄选',
            desc: '所有入驻咨询师均经5轮严格甄选，入驻通过率仅2%，高于行业标准'
          },
          {
            icon: 'filter',
            title: '资质担保',
            desc:
              '通过严格的人工审查机制，承诺所有咨询师的执业资质均经过真实性检验'
          },
          {
            icon: 'data',
            title: '7天退款到账',
            desc: '与咨询师协商确定取消咨询后，7天内自动退费'
          },
          {
            icon: 'examine',
            title: '咨询伦理保障',
            desc:
              '严守《中国心理学会临床与咨询心理学工作伦理守则》，严肃处理违反伦理的行为'
          },
          {
            icon: 'services',
            title: '专委会监督护航',
            desc:
              '4位心理咨询师领衔指导、6位资深咨询师为骨干,为咨询师胜任力审核、投诉监督、危机情况指导等重要工作保驾护航'
          }
        ]
      }
    },
    show: {
      type: Boolean,
      default: false
    },
    buttons: {
      type: Array,
      default() {
        return [{ label: '我知道了' }]
      }
    },
    zIndex: {
      type: Number,
      default: 2016
    }
  },
  methods: {
    close() {
      this.$emit('update:show', false)
    }
  }
}
</script>

<style lang="scss">
@import '../../../scss/functions';
.hp-up-popup-container {
  // 覆盖弹窗的样式
  .common-model-up-title {
    padding-bottom: pxToRem(16);
  }
}
.hp-up-popup-rule-model {
  padding: pxToRem(20) pxToRem(28);
  box-sizing: border-box;
  overflow: hidden;
  overflow-y: auto;
}
.common-model-up-container {
  max-height: calc(100vh - 7rem) !important;
}
.consult-ensure-rule-model-box {
  // .common-model-up-btns {
  //   position: relative;
  //   &:after {
  //     display: block;
  //     content: '';
  //     position: absolute;
  //     width: 100%;
  //     height: 60px;
  //     top: -60px;
  //     left: 0;
  //     background: #FFFFFF;
  //     border-radius: 30px;
  //     filter: blur(33px);
  //   }
  // }
  .common-model-up-btn {
    height: pxToRem(86);
    background: linear-gradient(180deg, #bdc9fd 0%, #5d70f9 100%);
    border-radius: pxToRem(48);
    .common-model-up-btn-label {
      font-size: pxToRem(32);
      font-weight: 600;
    }
  }
  .common-model-up-close-btn {
    display: none;
  }
}
.consult-ensure-rule-model {
  padding: pxToRem(20) pxToRem(30) pxToRem(43);
  .list {
    padding-left: pxToRem(46);
    padding-bottom: pxToRem(20);
    .desc {
      font-size: pxToRem(26);
      color: #6c798c;
      line-height: pxToRem(38);
      margin-bottom: pxToRem(50);
    }
    .desc-pb {
      margin-bottom: 0;
    }
  }
  .title {
    display: flex;
    align-items: center;
    font-size: pxToRem(32);
    color: #21252d;
    line-height: pxToRem(32);
    position: relative;
    margin-bottom: pxToRem(20);
    font-weight: 500;
    .item-icon {
      width: pxToRem(36);
      height: pxToRem(36);
      position: absolute;
      right: 100%;
      margin-right: pxToRem(13);
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .close-btn {
    font-size: pxToRem(26);
    color: #ffffff;
    line-height: pxToRem(28);
    height: pxToRem(80);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: pxToRem(80);
    background: #ffa202;
  }
  .expert-list {
    width: pxToRem(641);
    height: pxToRem(208);
    margin-bottom: pxToRem(20);
  }
}
</style>
